module.exports = __webpack_public_path__ + "static/img/success.528f201.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/success.png
// module id = 154
// module chunks = 39